/**
 * 編集可否スイッチを制御できるかどうかを判定する
 *
 * @param approvalFlowId - 承認フローID（0/null/undefinedの場合は承認フローなし）
 * @param canUseFeature - Feature Flag で承認フローなしの編集可否制御が許可されているか
 * @returns スイッチを制御できる場合はtrue
 */
export const canControlEditability = (
  approvalFlowId: number | null | undefined,
  canUseFeature: boolean,
): boolean => {
  // 承認フローが設定されている場合は常に制御可能
  // 0, null, undefined の場合は承認フローなしとして扱う
  if (approvalFlowId != null && approvalFlowId !== 0) {
    return true
  }

  // Feature Flag で承認フローなしの編集可否制御が許可されているかチェック
  return canUseFeature
}

/**
 * スイッチのチェック状態を計算する
 *
 * @param isEditable - 編集可能かどうか（storeの値）
 * @param canControl - スイッチを制御できるかどうか
 * @returns スイッチのチェック状態
 */
export const calculateSwitchChecked = (
  isEditable: boolean,
  canControl: boolean,
): boolean => {
  // 制御可能な場合は isEditable の値をそのまま使用
  // 制御不可能な場合は強制的にtrue（編集可）
  return canControl ? isEditable : true
}
